<template>
    <portal to="widget">
        <slot />
        <li
            v-if="can( $route.meta.parent || $route.name, 'add' ) && !$route.meta.hideWidgetAddOption"
            class="widget__list__option">
            <router-link
                class="widget__list__option__anchor position--relative accessibility--pseudo accessibility--pseudo--default"
                :to="`/${$route.meta.parent || $route.name}/add`"
            >
                {{ $t('global.add') + ' ' + $t(`global.${$route.name}`) }}
            </router-link>
        </li>
    </portal>
</template>

<script>
// components
import { Portal } from 'portal-vue';

// store
import { useStore } from '@/hooks/use-store';

export default {
    components: {
        Portal
    },
    setup () {
        const { getters: { can } } = useStore();

        return { can };
    }
};
</script>